import React, { Component } from "react";
import styled from 'styled-components';

import EmojiStronglyDisagree from "../../../containers/assets/bars-emoji-strongly-disagree.svg";
import EmojiNeutral from "../../../containers/assets/bars-emoji-neutral.svg";
import EmojiStronglyAgree from "../../../containers/assets/bars-emoji-strongly-agree.svg";

import { ContentContainerWithBackground } from '../components/ui';

const ProgressTitle = styled.h2`
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 12px;
  color: rgba(0, 27, 59, 0.94);
  text-transform: capitalize;
  text-align: center;
`;

const ProgressLineContainer = styled.div`
  display: flex;
  height: 40px;
  background: rgba(0, 27, 59, 0.04);
  border-radius: 100px;
  padding: 4px 4.5px;
  margin: 20px 21px 10.5px;
  position: relative;
`;

const RatingItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const RatingItem = styled.div`
  width: 32px;
  height: 32px;
  background: #52C5CD;
  border-radius: 100px;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
`;

const EmotionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 6px 20px;
`;

const EmotionItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 72px;

  img {
    margin-bottom: 4.5px;
    width: 25px;
    height: 25px;
  }

  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    color: rgba(0, 27, 59, 0.38);
  }
`;

const ChartLabel = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin: 0 6px;

  b {
    color: #EC5E59;
  }
`;

const rating = Array.from({ length: 5 }, (_, i) => i + 1);

class SkillsProgress extends Component {
  render() {
    const { title, progressValue } = this.props;

    const percentageWidth = ((progressValue - 1) / 4) * 100;

    const Progress = styled.div`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: calc(${percentageWidth}%);
      background: linear-gradient(270deg, #92DBE1 -51.2%, #D7F0F2 99.88%);
      border-radius: 100px;

      &:after {
        display: block;
        content: '${progressValue}';
        opacity: 0;
        text-align: center;
        position: absolute;
        right: 0;
        transform: translateX(50%);
        top: -30px;
        z-index: 1;
        transition: opacity .15s ease-in-out;
        padding: 3px 10px;
        border: 1px solid #D5D9DD;
        background: #fff;
      }

      &:hover:after {
        opacity: 1;
      }
    `;

    return (
      <ContentContainerWithBackground>
        <ProgressTitle>{title}</ProgressTitle>
        <ProgressLineContainer>
          <Progress />
          <RatingItems>
            {rating.map((item) => (
              <RatingItem
                key={item}
              >
                {item}
              </RatingItem>
            ))}
          </RatingItems>
        </ProgressLineContainer>
        <EmotionsContainer>
          <EmotionItem>
            <img src={EmojiStronglyDisagree} alt="Strongly Disagree" />
            <p>Needs work</p>
          </EmotionItem>
          <EmotionItem>
            <img src={EmojiNeutral} alt="Strongly Neutral" />
            <p>Great!</p>
          </EmotionItem>
          <EmotionItem>
            <img src={EmojiStronglyAgree} alt="Strongly Agree" />
            <p>Amazing!</p>
          </EmotionItem>
        </EmotionsContainer>
        <ChartLabel><b>*</b> A rating of 3 or higher = 100% </ChartLabel>
      </ContentContainerWithBackground>
    );
  }
}

export default SkillsProgress;


// WEBPACK FOOTER //
// ./src/components/peer-feedback/components/skills-progress.js